var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('m-assembly-table',{ref:"pageForm",attrs:{"thDrag":"","formData":_vm.formData,"columns":_vm.columns,"data":_vm.tableData,"tableButtons":_vm.tableButtons,"loading":_vm.loading,"settings":_vm.settings},on:{"onSubmit":_vm.onSubmit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }